import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { MultiSelect } from '@workwave-tidal/core/components'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import { useData, useHandlers } from './hooks'
import type { ENTITY_TYPES } from '@sales-center/common'
import { AssigneeOption } from '@user/store/salesTeam'

type Props = {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
  name: string
  disabled?: boolean
  salesTeamIds: number[]
  entityType: ENTITY_TYPES
  required: boolean
  errorText?: string
}

export function OwnerSelect(props: Props) {
  const { name, required, salesTeamIds, label, disabled, errorText } = props
  const {
    showError,
    isSubmitting,
    helperText,
    initialOptions,
    renderSummary,
    isOptionEqual,
    ...restUseData
  } = useData({ name, required, salesTeamIds, showUnAssignedOption: true })

  const { handleChange } = useHandlers({ name })
  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <MultiSelect<AssigneeOption>
        {...restUseData}
        testId="leadAssignmentOwnerInput"
        label={label || 'Owner'}
        disabled={disabled || isSubmitting}
        required={required !== undefined ? required : true}
        optionMode="custom"
        inputMode="summary"
        density="normal"
        value={initialOptions}
        sx={{
          backgroundColor: 'red',
        }}
        onChange={handleChange}
        autocompleteProps={{
          isOptionEqualToValue: isOptionEqual,
          size: 'small',
        }}
        renderOption={(props, owner: AssigneeOption) => (
          <MenuItem {...props} key={owner.id} value={owner.id}>
            <ListItemIcon>
              <Checkbox checked={initialOptions.includes(owner)} size="small" />
            </ListItemIcon>
            <Box>
              <Typography>{owner.name}</Typography>
            </Box>
          </MenuItem>
        )}
        renderSummary={(options) => renderSummary(options, 'Owners')}
        placeholder="Search more Owners"
        getLabel={(team) => team.name}
      />
      {(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }} error>
          {errorText || helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
